export const SOCIAL_PROFILES = {
  FACEBOOK: 'facebook',
  YOUTUBE: 'youtube',
  LINKEDIN: 'linkedin',
};
